import {
  Box,
  Card,
  CardContent,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import React, { useState } from "react";
import Chart from "react-apexcharts";

const PredictedTrendsWithCheckboxes = ({
  categories1,
  categories2,
  dataset1,
  dataset2,
  label1,
  label2,
}) => {
  const theme = useTheme();
  const [selectedOption, setSelectedOption] = useState("data1");

  const currentDataset = selectedOption === "data1" ? dataset1 : dataset2;
  const currentCategories =
    selectedOption === "data1" ? categories1 : categories2;

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const chart: any = currentDataset
    ? {
        series: [
          {
            name: "Min",
            type: "column",
            data: currentDataset.min,
            color: "#f4b73f",
          },
          {
            name: "Max",
            type: "column",
            data: currentDataset.max,
            color: "#1e4354",
          },
          {
            name: "Avg",
            type: "line",
            data: currentDataset.avg,
            color: "#5fc1f2",
          },
        ],
        options: {
          chart: {
            background: "transparent",
            stacked: false,
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          colors: ["#f4b73f", "#1e4354", "#5fc1f2"],
          grid: {
            borderColor: theme.palette.divider,
            strokeDashArray: 2,
          },
          legend: {
            position: "top",
            horizontalAlign: "right",
            labels: {
              colors: theme.palette.text.secondary,
            },
            show: true,
          },
          plotOptions: {
            bar: {
              columnWidth: "40%",
            },
          },
          stroke: {
            colors: ["transparent"],
            show: true,
            width: 2,
          },
          theme: {
            mode: theme.palette.mode,
          },
          tooltip: {
            theme: theme.palette.mode,
          },
          xaxis: {
            axisBorder: {
              show: true,
              color: theme.palette.divider,
            },
            axisTicks: {
              show: true,
              color: theme.palette.divider,
            },
            categories: currentCategories,
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
          yaxis: {
            axisBorder: {
              color: theme.palette.divider,
              show: true,
            },
            axisTicks: {
              color: theme.palette.divider,
              show: true,
            },
            labels: {
              style: {
                colors: theme.palette.text.secondary,
              },
            },
          },
        },
      }
    : {};
  return (
    <Card>
      <CardContent>
        <Box sx={{ pt: 1, pl: 1 }}>
          <FormControlLabel
            value="data1"
            control={
              <Radio
                color="primary"
                checked={selectedOption === "data1"}
                onChange={handleOptionChange}
              />
            }
            label={label1}
          />
          <FormControlLabel
            value="data2"
            control={
              <Radio
                color="primary"
                checked={selectedOption === "data2"}
                onChange={handleOptionChange}
              />
            }
            label={label2}
          />
        </Box>
        <Chart height={390} {...chart} />
      </CardContent>
    </Card>
  );
};

export default PredictedTrendsWithCheckboxes;
